import { useQueries } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_MAIL_MESSAGES } from '@/api/endpoints';
import { MAIL_MESSAGES_QUERY_KEY } from '@/api/queryKeys';
import { toMailMessage } from '@/pages/Mail/mailMessages';
import type { MailMessageResponse } from '@/types/mail';
import { unwrapAxiosResponse } from '@/utils/axios';

export const mailMessagesPageQueryKey = (pageIds: number[]) => [
  ...MAIL_MESSAGES_QUERY_KEY,
  pageIds,
];

export const useMailMessagePages = (
  idPages: number[][],
  loadedPageCount: number,
) => {
  const pageQueries = useQueries({
    queries: idPages.slice(0, loadedPageCount).map((pageIds) => {
      const commaSeparatedIds = pageIds.join(',');

      return {
        queryKey: mailMessagesPageQueryKey(pageIds),
        queryFn: () =>
          apiClient
            .get<MailMessageResponse[]>(API_MAIL_MESSAGES, {
              params: { commaSeparatedIds },
            })
            .then(unwrapAxiosResponse),
      };
    }),
  });

  const [firstPageQuery, ...nextPageQueries] = pageQueries;

  const mails = pageQueries.flatMap(
    (query) => query.data?.map(toMailMessage) ?? [],
  );
  const isFetchingFirstPage = firstPageQuery?.isFetching ?? false;
  const isFetchingNextPage = nextPageQueries.some((query) => query.isFetching);

  return { mails, isFetchingFirstPage, isFetchingNextPage };
};
